import { useMemo, useSyncExternalStore } from 'react'

import { AUTO_DESIGN_LAST_ACTIVITY_AT_MS_KEY, AUTO_DESIGN_RECENT_ACTIVITY_WINDOW_MS } from '../constants'

const autoDesignLastActivityListeners = new Set<() => void>()

export const subscribeAutoDesignLastActivity = (listener: () => void) => {
  autoDesignLastActivityListeners.add(listener)
  return () => {
    autoDesignLastActivityListeners.delete(listener)
  }
}

export const getAutoDesignLastActivityMs = (): number => {
  try {
    const v = localStorage.getItem(AUTO_DESIGN_LAST_ACTIVITY_AT_MS_KEY)
    return v ? parseInt(v, 10) : 0
  } catch {
    return 0
  }
}

export const touchAutoDesignLastActivity = () => {
  try {
    localStorage.setItem(AUTO_DESIGN_LAST_ACTIVITY_AT_MS_KEY, String(Date.now()))
  } catch {}
  autoDesignLastActivityListeners.forEach((l) => l())
}

export function useHasUsedAutoDesignInLast30Days(): boolean {
  const lastMs = useSyncExternalStore(subscribeAutoDesignLastActivity, getAutoDesignLastActivityMs, () => 0)

  return useMemo(() => lastMs > 0 && Date.now() - lastMs < AUTO_DESIGN_RECENT_ACTIVITY_WINDOW_MS, [lastMs])
}
